import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language || 'en');

  const switchLanguage = () => {
    const newLang = currentLanguage === 'en' ? 'he' : 'en';
    i18n.changeLanguage(newLang);
    setCurrentLanguage(newLang);
  };

  return (
    <div className="floating-button language-switcher">
      <button className="floating-button-icon" onClick={switchLanguage}>
        {currentLanguage === 'en' ? 'HE' : 'EN'}
      </button>
    </div>
  );
};

export default LanguageSwitcher;
